import { ToastAction } from '@/app/components/ui/toast';
import { toast } from '@/app/components/ui/use-toast';

interface ShowUpgradeToastOptions {
  /** 提示文案 */
  message: string;
  /** 升级按钮文案 */
  actionText: string;
  /** 点击升级按钮的回调，通常是打开套餐弹窗 */
  onAction: () => void;
}

/**
 * 升级引导 toast：替代原先直接弹出的订阅弹窗，避免打断用户操作的连贯性。
 * 用户仍可通过 toast 内的升级按钮进入套餐弹窗，转化路径不丢失。
 */
export const showUpgradeToast = ({ message, actionText, onAction }: ShowUpgradeToastOptions) => {
  toast({
    type: 'custom',
    message,
    duration: 5000,
    containerClassName:
      '-translate-x-1/2 absolute top-24 left-1/2 flex w-fit items-center justify-center gap-3 rounded-12 border-none bg-[rgba(75,80,86,0.32)] p-3 backdrop-blur-[60px] lg:p-3',
    contentClassName: 'font-medium text-sm text-system-white opacity-100',
    action: (
      <ToastAction
        altText={actionText}
        onClick={onAction}
        className="h-auto rounded-6 border-none bg-ShengshuButton px-3 py-1 font-semibold text-black text-xs hover:bg-ShengshuButtonHover"
      >
        {actionText}
      </ToastAction>
    ),
  });
};
